if (!customElements.get("video-with-overlay")) {
  class t extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      (this.video = this.querySelector("video")),
        (this.overlay = this.querySelector(".video-overlay")),
        (this.parentClass = this.dataset.outsideButtonParentClass),
        (this.playButton = this.parentClass
          ? this.closest(`.${this.parentClass}`)?.querySelector(
              ".video-custom-button"
            )
          : this.querySelector(".video-custom-button")),
        this.overlay?.addEventListener("click", (t) => this.toggleVideo(t)),
        this.video?.addEventListener("click", (t) => this.toggleVideo(t)),
        "true" !== this.dataset.customButtonDisabled &&
          this.playButton?.addEventListener("click", (t) =>
            this.toggleVideo(t)
          );
    }
    toggleVideo(t) {
      t.preventDefault(),
        t.stopPropagation(),
        this.video?.paused ? this.video?.play() : this.video?.pause(),
        this.video.muted = !this.video.muted,
        this.playButton?.classList.toggle("hidden"),
        this.overlay?.classList.toggle("hidden");
    }
  }
  customElements.define("video-with-overlay", t);
}
